import { render } from "./Settings.vue?vue&type=template&id=5daa99ea"
const script = {}

import exportComponent from "/home/viapanelqualisof/admin.exchange.qualisoft.biz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__